<div>
	<div class="summary-and-filter-container">
		<div>
			<div class="title">{{ client()?.active_text?.name }}</div>
			<app-stride-school-report-summary [report]="report()"></app-stride-school-report-summary>
		</div>
	</div>

	<app-reporting-table [loading]="loading()" [rows]="rows()" [columns]="columns()">
		<!-- Header templates (defines order/keys) -->
		<ng-template appHeaderColumn="sectionName">Class</ng-template>
		<ng-template appHeaderColumn="teacher">Teacher</ng-template>
		<ng-template appHeaderColumn="listening">Listening</ng-template>
		<ng-template appHeaderColumn="reading">Reading</ng-template>
		<ng-template appHeaderColumn="speaking">Speaking</ng-template>
		<ng-template appHeaderColumn="writing">Writing</ng-template>
		<ng-template appHeaderColumn="composite">Composite</ng-template>
		<ng-template appHeaderColumn="activities">Activities Completed</ng-template>

		<!-- Cell templates (matched by key; use {{ row.name }} etc.) -->
		<ng-template appRowColumn="sectionName" let-row>
			<div class="name-column" (click)="onRowClick(row)">{{ row.sectionName }}</div>
		</ng-template>
		<ng-template appRowColumn="teacher" let-row>
			{{
				row.teacherUuids && row.teacherUuids.length > 0
					? (row.teacherUuids[0] | displayName: 'user' | async)
					: 'Not assigned yet'
			}}
			@if (row.teacherUuids && row.teacherUuids.length > 1) {
				<span class="extra-teachers">+{{ row.teacherUuids.length - 1 }}</span>
			}
		</ng-template>
		<ng-template appRowColumn="listening" let-row>
			<div class="skill-row">
				<span>{{ row.listening.average }}</span>
				<app-section-skill-distribution-bar
					[levels]="row.listening.levels"
					skill="listening"
					[average]="row.listening.average"
				></app-section-skill-distribution-bar>
			</div>
		</ng-template>
		<ng-template appRowColumn="reading" let-row>
			<div class="skill-row">
				<span>{{ row.reading.average }}</span>
				<app-section-skill-distribution-bar
					[levels]="row.reading.levels"
					skill="reading"
					[average]="row.reading.average"
				></app-section-skill-distribution-bar>
			</div>
		</ng-template>
		<ng-template appRowColumn="speaking" let-row>
			<div class="skill-row">
				<span>{{ row.speaking.average }}</span>
				<app-section-skill-distribution-bar
					[levels]="row.speaking.levels"
					skill="speaking"
					[average]="row.speaking.average"
				></app-section-skill-distribution-bar>
			</div>
		</ng-template>
		<ng-template appRowColumn="writing" let-row>
			<div class="skill-row">
				<span>{{ row.writing.average }}</span>
				<app-section-skill-distribution-bar
					[levels]="row.writing.levels"
					skill="writing"
					[average]="row.writing.average"
				></app-section-skill-distribution-bar>
			</div>
		</ng-template>
		<ng-template appRowColumn="composite" let-row>
			<div class="skill-row">
				<span>{{ row.composite.average }}</span>
				<app-section-skill-distribution-bar
					[levels]="row.composite.levels"
					skill="composite"
					[average]="row.composite.average"
				></app-section-skill-distribution-bar>
			</div>
		</ng-template>
		<ng-template appRowColumn="activities" let-row>
			{{ row.activityCount | number }}
			( {{ row.studentCount | number }}
			<nz-icon nzType="user" nzTheme="outline" />
			)
		</ng-template>
	</app-reporting-table>
</div>
